import appConfig from '../config/app.config'

/**
 * Normalises any recognisable YouTube URL to the embed form.
 *
 *   https://www.youtube.com/watch?v=ID  → {embedBase}/embed/ID
 *   https://youtu.be/ID                 → {embedBase}/embed/ID
 *   https://www.youtube.com/embed/ID    → unchanged
 *
 * Returns null for empty or unrecognised URLs so callers can conditionally render.
 */
export function toYouTubeEmbedUrl(url: string): string | null {
  if (!url) return null
  try {
    const parsed = new URL(url)

    // Already an embed URL — return as-is
    if (parsed.pathname.startsWith('/embed/')) return url

    // Short-link: youtu.be/ID
    if (parsed.hostname === 'youtu.be') {
      const id = parsed.pathname.slice(1)
      return id ? `${appConfig.youtubeEmbedBase}/embed/${id}` : null
    }

    // Standard: youtube.com/watch?v=ID
    if (parsed.hostname.endsWith('youtube.com')) {
      const id = parsed.searchParams.get('v')
      return id ? `${appConfig.youtubeEmbedBase}/embed/${id}` : null
    }

    return null
  } catch {
    return null
  }
}
